var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1.5C7.035 1.5 5.4375 3.0975 5.4375 5.0625C5.4375 6.99 6.945 8.55 8.91 8.6175C8.97 8.61 9.03 8.61 9.075 8.6175C9.09 8.6175 9.0975 8.6175 9.1125 8.6175C9.12 8.6175 9.12 8.6175 9.1275 8.6175C11.0475 8.55 12.555 6.99 12.5625 5.0625C12.5625 3.0975 10.965 1.5 9 1.5Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8097 10.6125C10.7172 9.21747 7.30473 9.21747 5.19723 10.6125C4.24473 11.25 3.71973 12.1125 3.71973 13.035C3.71973 13.9575 4.24473 14.8125 5.18973 15.4425C6.23973 16.1475 7.61973 16.5 8.99973 16.5C10.3797 16.5 11.7597 16.1475 12.8097 15.4425C13.7547 14.805 14.2797 13.95 14.2797 13.02C14.2722 12.0975 13.7547 11.2425 12.8097 10.6125Z",
    fill: "#292D32"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.d56ce30ba11a34ccfda0bf8265ffa012.svg";
export { ForwardRef as ReactComponent };